import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AppShell } from 'shared/components/AppShell';
import { useAuth } from 'shared/contexts/AuthContext';
import { getAdminNav } from '../../navigation';

/** Admin area shell: navy header + admin sidebar, wrapping every admin route. No org model to resolve (unlike ManagerLayout), so no loading/error state. */
export function AdminLayout() {
  const { pathname } = useLocation();
  const { isAdmin, isContractorAdmin } = useAuth();
  const adminPathSegments = pathname.split('/').filter(Boolean);
  const isDirectTool = adminPathSegments[0] === 'admin' && ['customers', 'message-board', 'opportunities'].includes(adminPathSegments[1]);
  const isToolPage = (adminPathSegments[0] === 'admin' && adminPathSegments.length > 2) || isDirectTool;

  return (
    <AppShell nav={getAdminNav({ isAdmin, isContractorAdmin })} hideSidebarOnMobile fullWidth={isToolPage}>
      <div className="admin-content min-w-0">
        <Outlet />
      </div>
    </AppShell>
  );
}
